import { verifyAccessRights, convertAccessRightID2Description } from './verifyAccessRights';

export interface AccessRightsGroup {
  name: string;
  description: string;
  resources: AccessRightsResource[];
}

export interface AccessRightsResource {
  resourceID: number;
  constant: string;
  features: number[];
  name: string;
  description: string;
}

export interface AccessRightsFeature {
  featureID: number;
  constant: string;
  name: string;
}

export enum Feature {
  ENABLE = 1,
  LIST = 2,
  VIEW = 3,
  EDIT = 4,
  CREATE = 5,
  DELETE = 6,
}

// NOTE! four digits are reserved in the final resource+featureID for the featureID
// so never create featureIDs larger than 9999
export const accessRightsFeatures: AccessRightsFeature[] = [
  { featureID: 1, constant: 'ENABLE', name: 'Enable' }, // NOTE! _ENABLE is not added to constant
  { featureID: 2, constant: 'LIST', name: 'List' },
  { featureID: 3, constant: 'VIEW', name: 'View' },
  { featureID: 4, constant: 'EDIT', name: 'Edit' },
  { featureID: 5, constant: 'CREATE', name: 'Create' },
  { featureID: 6, constant: 'DELETE', name: 'Delete' },
];

// This is the access rights setup
// NOTE1! Sort order is important and is the same sort order as used in the UI
export const accessRightsGroups: AccessRightsGroup[] = [
  {
    name: 'User',
    description: '',
    resources: [
      {
        resourceID: 2001,
        constant: 'USER', // JUST A TEMP PLACEHOLDER ACCESS RIGHT, REPLACE WITH BETTER ONES LATER
        features: [Feature.ENABLE],
        name: 'User',
        description: 'Demo user generic rights',
      },
      /*{
        resourceID: 2002,
        constant: 'CUSTOMERS',
        features: [Feature.LIST, Feature.VIEW, Feature.EDIT, Feature.DELETE],
        name: 'Customers',
        description: '',
      },*/
    ],
  },

  {
    name: 'System Administration',
    description: '',
    resources: [
      {
        resourceID: 3001,
        constant: 'ADMIN_PAGES', // JUST A TEMP PLACEHOLDER ACCESS RIGHT, REPLACE WITH BETTER ONES LATER
        features: [Feature.ENABLE],
        name: 'Administrator pages',
        description: 'General access to admin/development area',
      },
    ],
  },

  {
    name: 'Trial User',
    description: '',
    resources: [
      {
        resourceID: 4001,
        constant: 'TRIAL_USER', // JUST A TEMP PLACEHOLDER ACCESS RIGHT, REPLACE WITH BETTER ONES LATER
        features: [Feature.ENABLE],
        name: 'Trial User',
        description: 'Demo user generic rights',
      },
      {
        resourceID: 4002,
        constant: 'ANONYMOUS_USER', // JUST A TEMP PLACEHOLDER ACCESS RIGHT, REPLACE WITH BETTER ONES LATER
        features: [Feature.ENABLE],
        name: 'Anonymous User',
        description: 'User not connected to GitHub',
      },
    ],
  },

  {
    name: 'Development',
    description: '',
    resources: [
      {
        resourceID: 9001, // JUST A TEMP PLACEHOLDER ACCESS RIGHT, REPLACE WITH BETTER ONES LATER
        constant: 'DEVELOPMENT',
        features: [Feature.ENABLE],
        name: 'Development',
        description: 'Developer generic rights',
      },
    ],
  },
];

export function accessRightDescription(accessRightID: number) {
  return convertAccessRightID2Description(accessRightID, accessRightsGroups, accessRightsFeatures);
}

//
// List of actual IDs
//
// To avoid the work to manually update this do this
// 1) Update the list above
// 2) Restart api, it will detect that the constants are off and generate new code for the following section
// 3) Update the constants below and restart the api/client
//

export const AccessRights = {
  USER: 20010001,
  ADMIN_PAGES: 30010001,
  TRIAL_USER: 40010001,
  ANONYMOUS_USER: 40020001,
  DEVELOPMENT: 90010001,
};

verifyAccessRights(accessRightsGroups, accessRightsFeatures, AccessRights);
